import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { isChannel } from "@website/utils/channel/helpers";
import { numberConvert } from "@website/utils/number-convert";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { ChatBotExperimentModalHost } from "@website/widget/chat-bot";
import { ContactPhone } from "@website/widget/footer/contact-phone";
import { FooterRow } from "@website/widget/footer/footer-row";
import { applications, contactUs, copyright, snappSocialMediaLinks, socialMediaLinks, support } from "@website/widget/footer/footer.constants";
import { useFooter } from "@website/widget/footer/footer.hook";
import styles from "@website/widget/footer/footer.module.scss";
import { FooterPropertiesType } from "@website/widget/footer/footer.types";
import { SupportContact } from "@website/widget/footer/support-contact";
import { FC } from "react";
export const FooterComponent: FC<FooterPropertiesType> = properties => {
  const $ = _c(48);
  const {
    includeChatbot: t0,
    minimalView,
    isShowSupportNumber: t1,
    isShowBolderPlateLinks: t2,
    hasB2BContact: t3,
    hasDownloadApp: t4
  } = properties;
  const includeChatbot = t0 === undefined ? true : t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? !isChannel(["b2b", "telesale"]) : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const isShowSupportNumber = t5;
  let t6;
  if ($[2] !== t2) {
    t6 = t2 === undefined ? !isChannel(["b2b", "telesale"]) : t2;
    $[2] = t2;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const isShowBolderPlateLinks = t6;
  let t7;
  if ($[4] !== t3) {
    t7 = t3 === undefined ? isChannel(["b2b", "telesale"]) : t3;
    $[4] = t3;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const hasB2BContact = t7;
  let t8;
  if ($[6] !== t4) {
    t8 = t4 === undefined ? !isChannel(["b2b", "snapp-ir", "telesale"]) : t4;
    $[6] = t4;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const hasDownloadApp = t8;
  const {
    certificates,
    links,
    moreInfo,
    services
  } = useFooter();
  let t9;
  if ($[8] !== includeChatbot) {
    t9 = includeChatbot && <ChatBotExperimentModalHost />;
    $[8] = includeChatbot;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== isShowSupportNumber) {
    t10 = isShowSupportNumber && <FooterRow><SupportContact classNames={{
        phone: styles["support-phone"],
        phoneIcon: styles["support-phone-icon"],
        phoneText: styles["support-phone-text"],
        support: styles.support,
        title: styles["support-title"]
      }} phoneNumber={support.phoneNumber} /></FooterRow>;
    $[10] = isShowSupportNumber;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== isShowBolderPlateLinks || $[13] !== links || $[14] !== minimalView || $[15] !== moreInfo || $[16] !== services) {
    t11 = !minimalView && isShowBolderPlateLinks && <FooterRow><div className={styles.links}>{!isChannel(["snapp-ir"]) && <div className={styles["links-column"]}><div className={styles["links-column-title"]}>خدمات مسافرتی</div><div className={styles["links-column-list"]}>{services.map(_temp)}</div></div>}{!isChannel(["snapp-ir"]) && <div className={styles["links-column"]}><div className={styles["links-column-title"]}>امکانات</div><div className={styles["links-column-list"]}>{links.map(_temp2)}</div></div>}<div className={styles["links-column"]}><div className={styles["links-column-title"]}>اطلاعات بیشتر</div><div className={styles["links-column-list"]}>{moreInfo.map(_temp3)}</div></div></div></FooterRow>;
    $[12] = isShowBolderPlateLinks;
    $[13] = links;
    $[14] = minimalView;
    $[15] = moreInfo;
    $[16] = services;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={styles["contact-us-title"]}>ارتباط با ما</div>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== hasB2BContact) {
    t13 = !hasB2BContact && <><div className={styles["contact-us-item"]}><div className={styles["contact-us-item-key"]}>آدرس</div><div className={styles["contact-us-item-value"]}>{isChannel(["snapp-ir"]) ? "\u062A\u0647\u0631\u0627\u0646\u060C \u0632\u0639\u0641\u0631\u0627\u0646\u06CC\u0647\u060C \u062E\u06CC\u0627\u0628\u0627\u0646 \u0634\u0647\u06CC\u062F \u0641\u0644\u0627\u062D\u06CC\u060C \u062A\u0642\u0627\u0637\u0639 \u062E\u06CC\u0627\u0628\u0627\u0646 \u0645\u0642\u062F\u0633 \u0627\u0631\u062F\u0628\u06CC\u0644\u06CC\u060C \u067E\u0644\u0627\u06A9 \u06F2" : "\u0628\u0644\u0648\u0627\u0631 \u0646\u0644\u0633\u0648\u0646 \u0645\u0627\u0646\u062F\u0644\u0627\u060C \u062A\u0642\u0627\u0637\u0639 \u0622\u0631\u0634 \u063A\u0631\u0628\u06CC\u060C \u0646\u0628\u0634 \u06A9\u0648\u0686\u0647 \u0627\u06CC\u0631\u062C\u060C \u067E\u0644\u0627\u06A9 \u06F1\u06F1\u06F5"}</div></div><div className={styles["contact-us-item"]}><div className={styles["contact-us-item-key"]}>کد پستی:</div><div className={styles["contact-us-item-value"]}>{numberConvert(contactUs.zipCode, {
            numberOnly: false,
            locale: "fa"
          })}</div></div><ContactPhone classNames={{
        item: styles["contact-us-item"],
        key: styles["contact-us-item-key"],
        value: styles["contact-us-item-value"]
      }} phoneNumberPrefix={contactUs.phoneNumberPrefix} phoneNumbers={contactUs.phoneNumbers} /></>;
    $[19] = hasB2BContact;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== hasB2BContact) {
    t14 = hasB2BContact && <><div className="text-on-surface-high-emphasis mt-1 flex items-center gap-4">پشتیبانی ۲۴ ساعته و ۷ روز هفته<a dir="ltr" href="tel:02192000123">۰۲۱ ۹۲۰۰۰۱۲۳ (داخلی ۳)</a></div><div className={styles["contact-us-item"]}><div className={styles["contact-us-item-key"]}>آدرس:</div><div className={styles["contact-us-item-value"]}>{isChannel(["snapp-ir"]) ? "\u062A\u0647\u0631\u0627\u0646\u060C \u0632\u0639\u0641\u0631\u0627\u0646\u06CC\u0647\u060C \u062E\u06CC\u0627\u0628\u0627\u0646 \u0634\u0647\u06CC\u062F \u0641\u0644\u0627\u062D\u06CC\u060C \u062A\u0642\u0627\u0637\u0639 \u062E\u06CC\u0627\u0628\u0627\u0646 \u0645\u0642\u062F\u0633 \u0627\u0631\u062F\u0628\u06CC\u0644\u06CC\u060C \u067E\u0644\u0627\u06A9 \u06F2" : "\u0628\u0644\u0648\u0627\u0631 \u0646\u0644\u0633\u0648\u0646 \u0645\u0627\u0646\u062F\u0644\u0627\u060C \u062A\u0642\u0627\u0637\u0639 \u0622\u0631\u0634 \u063A\u0631\u0628\u06CC\u060C \u0646\u0628\u0634 \u06A9\u0648\u0686\u0647 \u0627\u06CC\u0631\u062C\u060C \u067E\u0644\u0627\u06A9 \u06F1\u06F1\u06F5"}</div></div></>;
    $[21] = hasB2BContact;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13 || $[24] !== t14) {
    t15 = <div className={styles["contact-us"]}>{t12}{t13}{t14}</div>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className={styles["social-media-title"]}>شبکه های اجتماعی</div>;
    t17 = <div className={styles["social-media-description"]}>با ما در ارتباط باشید</div>;
    $[26] = t16;
    $[27] = t17;
  } else {
    t16 = $[26];
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className={styles["social-media"]}>{t16}{t17}<div className={styles["social-media-list"]}>{(isChannel(["snapp-ir"]) ? snappSocialMediaLinks : socialMediaLinks).map(_temp4)}</div></div>;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t15) {
    t19 = <FooterRow><div className={styles.contact}>{t15}{t18}</div></FooterRow>;
    $[29] = t15;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== hasDownloadApp || $[32] !== minimalView) {
    t20 = !minimalView && hasDownloadApp && <FooterRow><div className={styles["download-app"]}><div className={styles["download-app-content"]}><div className={styles["download-app-title"]}>دانلود اپلیکیشن</div></div><div className={styles["download-app-list"]}>{applications.map(_temp5)}<a href="https://www.snapptrip.com/" className="flex h-[48px] w-[161px] items-center justify-between rounded-md bg-[#0C0D10] px-3 py-0" rel="nofollow"><p className="text-extra-caption text-[#fff]">نسخه وب اپلیکیشن</p><div className="text-[16px] font-bold text-[#FFF]">PWA</div></a><a className="hidden md:block" href="/apps"><Button className="!bg-on-surface-medium-emphasis !h-[48px] !w-[48px]" size="large" variant="contained" color="neutral" StartIcon={<MaterialIcon name="chevron_left" />} /></a></div></div></FooterRow>;
    $[31] = hasDownloadApp;
    $[32] = minimalView;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className={styles["about-us-title"]}>{replaceSnappTripBasedOnChannel("\u062F\u0631\u0628\u0627\u0631\u0647 \u06CC \u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E")}</div>;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className={styles["about-us-content"]}>{t21}<div className={styles["about-us-description"]}>{replaceSnappTripBasedOnChannel("\u062F\u0631 \u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E \u0628\u0627 \u0686\u0646\u062F \u06A9\u0644\u06CC\u06A9 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u067E\u0631\u0648\u0627\u0632\u0647\u0627 \u0648 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u06CC \u0645\u062E\u062A\u0644\u0641 \u0631\u0627 \u0628\u0631\u0631\u0633\u06CC \u06A9\u0631\u062F\u0647 \u0648 \u0628\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0645\u0646\u0627\u0633\u0628\u200C\u062A\u0631\u06CC\u0646 \u06AF\u0632\u06CC\u0646\u0647\u200C\u0647\u0627 \u0633\u0641\u0631 \u062E\u0648\u0634\u06CC \u0631\u0627 \u062A\u062C\u0631\u0628\u0647 \u06A9\u0646\u06CC\u062F.")}</div></div>;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== certificates) {
    t23 = certificates.map(_temp6);
    $[36] = certificates;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t23) {
    t24 = <FooterRow><div className={styles["about-us"]}>{t22}<div className={styles["about-us-list"]}>{t23}</div></div></FooterRow>;
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <FooterRow background="gray"><div className={styles.copyright}><div className={styles["copyright-item"]}>از مطالب این وب‌سایت فقط می‌توانید برای مقاصد غیرتجاری و با ذکر منبع استفاده کنید.{!isChannel(["snapp-ir"]) && " \u062A\u0645\u0627\u0645\u06CC \u062D\u0642\u0648\u0642 \u0627\u06CC\u0646 \u0648\u0628\u200C\u0633\u0627\u06CC\u062A \u0628\u0647 \u0634\u0631\u06A9\u062A \u0622\u0631\u0627 \u062C\u0647\u0627\u0646 \u0646\u0648\u06CC\u0646 \u06AF\u0633\u062A\u0631 \u0627\u0637\u0644\u0633 \u062A\u0639\u0644\u0642 \u062F\u0627\u0631\u062F."}</div><div className={styles["copyright-item"]} suppressHydrationWarning={true}>{copyright.sign}</div></div></FooterRow>;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== t10 || $[42] !== t11 || $[43] !== t19 || $[44] !== t20 || $[45] !== t24 || $[46] !== t9) {
    t26 = <footer className={styles.footer}>{t9}{t10}{t11}{t19}{t20}{t24}{t25}</footer>;
    $[41] = t10;
    $[42] = t11;
    $[43] = t19;
    $[44] = t20;
    $[45] = t24;
    $[46] = t9;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  return t26;
};
function _temp(item) {
  return <a className={styles["links-column-item"]} href={item.url} key={item.url}>{item.title}</a>;
}
function _temp2(item_0) {
  return <a className={styles["links-column-item"]} href={item_0.url} itemScope={true} key={`${item_0?.title}-${item_0?.url}`} {...item_0.nofollow && {
    rel: "nofollow"
  }}>{item_0.title}</a>;
}
function _temp3(item_1) {
  return <a className={styles["links-column-item"]} href={item_1.url} itemScope={true} key={item_1?.url}>{item_1.title}</a>;
}
function _temp4(item_2) {
  return <Button EndIcon={item_2.icon} aria-label={item_2.ariaLabel} className={styles["social-media-item"]} color="neutral" equalDimension={true} href={item_2.url} key={item_2.url} rel={item_2.rel} role="link" size="x-small" target="_blank" variant="text" />;
}
function _temp5(item_3) {
  return <a className={styles["download-app-item"]} href={item_3?.url} itemScope={true} key={item_3?.url} rel="noreferrer nofollow" target="_blank">{item_3?.image && <LazyImage alt={item_3?.alt} height={item_3?.height} loading="lazy" src={item_3?.image} width={item_3?.width} />}</a>;
}
function _temp6(item_4) {
  return <div className={styles["about-us-item"]} itemScope={true} key={item_4?.id}>{item_4?.src && <LazyImage {...item_4} />}</div>;
}